import React from 'react';

const AnnouncementBar = () => (
  <div className='bg-yellow' role='region' aria-label='Site announcement'>
    <div className='container mx-auto px-8 py-2'>
      <p className='font-soft font-semibold text-sm text-blue-900 text-center leading-snug'>
        Enrollment for the NL Genome Project is currently paused for a planned data lock and analysis phase.
      </p>
    </div>
  </div>
);

export default AnnouncementBar;
